import { render, staticRenderFns } from "./ApplicationData.vue?vue&type=template&id=a665cf1c&scoped=true&"
import script from "./ApplicationData.vue?vue&type=script&lang=js&"
export * from "./ApplicationData.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationData.vue?vue&type=style&index=0&id=a665cf1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a665cf1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardTitle,VChip,VSkeletonLoader})
